import initialState from './initialState'
import {CALCULATED_RATE, RESET_RATE} from '../actions/actionTypes'

export default function calculatedRate(state = initialState.calculatedRate, action) {
	let newState
	switch (action.type) {
	case CALCULATED_RATE:
		newState = action.calculatedRate
		return {
			...state,
			...newState
		}
	case RESET_RATE:
		newState = action.calculatedRate
		return {
			...state,
			...newState, 
			total: null
		}
	default:
		return state
	}
}